var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('vs-button',{attrs:{"color":_vm.params.colDef.color},on:{"click":_vm.doClick}},[_vm._v(_vm._s(_vm.params.colDef.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }